window.banersswipers = {};
window.products_sliderFun = function(id) {
  if (window.banersswipers[id] !== undefined) {
    window.banersswipers[id].destroy();
  }
  window.banersswipers[id] = new Swiper('.swiper-container.swiper'+id, {
    observer: true,
    slidesPerView: 2,
    initialSlide: 0,
    navigation: {
      nextEl: '.product-recommendation .swiper-button-next',
      prevEl: '.product-recommendation .swiper-button-prev',
    }, 
    breakpoints: {
      800: {
      	slidesPerView: 2,
      },
      1030: {
      	slidesPerView: 3,
      },
      1200: {
      	slidesPerView: 4,
      }
    }
  })
};
window.baners_sliderFun = function(id) {
  let _slidesPerView = parseInt($('.swiper'+id+'[data-row]').attr('data-row'));
 
  if (window.banersswipers[id] !== undefined) {
    window.banersswipers[id].destroy();
  }
  window.banersswipers[id] = new Swiper('.swiper-container.swiper'+id, {
    observer: true,
    slidesPerView: 'auto',
    initialSlide: 0,    
    breakpoints: {
      750: {
      	slidesPerView: _slidesPerView,
      }
    }
  })
  if($('.template-404').length > 0){
    setTimeout(function(){ window.banersswipers[id].update() }, 200);
  }
};
window.listswipers = {};
window.sliderFun = function(id) {
  let _slidesPerView = parseInt($('.swiper'+id+'[data-row]').attr('data-row')),
      _centeredSlides = $('.swiper'+id+'[data-row]').attr('swiper-centeredSlides') == "true" ? true:false,
      _delay = parseInt($('.swiper'+id+'[data-play]').attr('data-play')) * 1000;
  
  if (window.listswipers[id]) {
    window.listswipers[id].destroy();
  }

  window.listswipers[id] = new Swiper('.swiper-container.swiper'+id, {
    observer: true,
    slidesPerView: 'auto',
    initialSlide: 0,
    centeredSlides: _centeredSlides,
    loop: _delay == 0 ? false : true,
    autoplay: _delay == 0 ? false : {
      delay: _delay,
      disableOnInteraction: false,
    },
    breakpoints: {
      750: {
      	slidesPerView: _slidesPerView,
      }
    }
  })
  
  if ( _delay > 0 ) {
    
    $('.swiper-container.swiper'+id).hover(function() {
        (this).swiper.autoplay.stop();
    }, function() {
        (this).swiper.autoplay.start();
    });
    
  }
}
window.footerFun = function(){
  if($('#shopify-section-footer .site-footer__item').length > 0) {    
    $.each($('#shopify-section-footer .site-footer__item'), (key, val) => {
      let $header = $('.h4', $(val));
      $header.unbind("click");
  
      $header.bind("click", function(){
        if($(window).width() < 1000) {
          if($header.closest('.site-footer__item').hasClass('pre-open')) {
          	$header.closest('.site-footer__item').removeClass('pre-open');
            $( '~ *' , $header).slideDown(0);
          }
          if($header.closest('.site-footer__item').hasClass('open')) {
            $header.closest('.site-footer__item').removeClass('open');
          	$( '~ *' , $header).slideUp('slow');
          }else {
          	$(this).closest('.site-footer__item').addClass('open');
            $( '~ *' , $header).slideDown('slow');
          }
        }
      });
    })
  }
  if($('#ContactFooter').length > 0) {
    $('#ContactFooter .newsletter-label').slideUp(0);
    $('#ContactFooter [type="email"]').keyup(function(){
      $('#ContactFooter .newsletter-label').slideDown();
    })
  }
}
window.product_sliderFun = () => {
  if( $('#product-photos').length > 0 ) {
    let phone = window.media_queries.phoneAndUp,
        _direction = $( window ).width() < phone ? 'horizontal' : 'vertical';
    window.productSlider = new Swiper ('#product-photos', {
      observer: true,
      initialSlide: 0,
      slidesPerView: 1,
      direction: _direction,
      navigation: {
        nextEl: '#product-photos .swiper-button-next',
        prevEl: '#product-photos .swiper-button-prev',
      },
      breakpoints: {
        769: {
          slidesPerView: 3,
        }
      }
    })
    if (window.productSlider) {
      window.productSlider.update();
    }  

    $( window ).resize( () => {
      if( $( window ).width() <= phone ) {
        window.productSlider.changeDirection('horizontal');
      }
      if( $( window ).width() > phone) {
        window.productSlider.changeDirection('vertical');
      }
    })
  }
}

// Select the node that will be observed for mutations
var targetNode = document.getElementById('watch');

// Options for the observer (which mutations to observe)
var config = { childList: true };

// Callback function to execute when mutations are observed
var callback = function(mutationsList, observer) {
    for(var mutation of mutationsList) {
        if (mutation.type == 'childList') {
            wishlist.count();
//             console.log('wishlist count change');
        }
    }
};

// Create an observer instance linked to the callback function
var observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

let wishlist = {
    changeView: () => {

      // options
      const config = {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      };

      // Create an observer instance linked to the callback function
      const cartObserver = new MutationObserver(function(mutations) {
        $.each(mutations, (i,mutation) => {
          if (mutation.type == 'childList') {
            wishlist.productHandle();
//             console.log('wishlist change view');
          }
        });
      });

      // Start observing the target node for configured mutations	
      cartObserver.observe($('#wishlistCollection')[0], config);
    },
	productHandle: () => {
      $.each($('.wk-item-column'), ( key, item ) => {
        let _productHandle = $( '.wk-variant-link', $(item) ).attr( 'href' ).replace( '/products/', '' );
        if ( _productHandle.indexOf('?') > 0) _productHandle = _productHandle.substring(0, _productHandle.indexOf('?'));
        $( item ).attr( 'handle', _productHandle );
      });
	},
  	getImage: () => {
      
      $.each($('.wk-item-column'), ( key, item ) => {
  		let _productHandle = $( '.wk-variant-link', $(item) ).attr( 'href' ).replace( '/products/', '' );
  		if ( _productHandle.indexOf('?') > 0) _productHandle = _productHandle.substring(0, _productHandle.indexOf('?'));
        $( item ).attr( 'handle', _productHandle );
        
//         $.getJSON('/products/'+_productHandle+'.js', function(product) {
//           $( '.wk-variant-link[href*="'+product.handle+'"]', $(item) ).addClass('img-change')
//           $( '.wk-variant-link[href*="'+product.handle+'"] img', $(item) ).attr('src', 'https://'+product.images[0])
//         })
        
        $.getJSON('/products/'+_productHandle+'.js', function(product) {
          let temp = $('.def').clone().removeClass('def');
          console.log(temp);
          
          if ( $('[product-id="'+product.id+'"]').length == 0 ) {
          
            $( '[link]', $(temp)).attr('href', product.url);
            $( '[image]', $(temp)).attr({src: 'https://'+product.images[0], alt: product.title})
            $( '[title]', $(temp)).text(product.title);

            $( '[price] span', $(temp)).text(theme.Currency.formatMoney(product.price, theme.moneyFormat));
            
            product.compare_at_price !== null ? $( '[price] del', $(temp)).text(theme.Currency.formatMoney(product.compare_at_price, theme.moneyFormat)) : $( '[price] del', $(temp)).remove() ;
            
            $( '[destroy]', $(temp) ).hide().click( () => {
            	$('.wk-item-column[handle="'+product.handle+'"] .wk-remove-item').click();
            	$(temp).fadeOut( '150' );
            	setTimeout(function(){ $(temp).remove() }, 151);
            	wishlist.productHandle();
            } );
          
            if ( $('.wk-item-column[handle="'+product.handle+'"] .wk-remove-product').length > 0 ) {
              $( '[like]', $(temp) ).addClass( 'active' )
            }else {
              $( '[like]', $(temp) ).hide();
            }
          
          	$( '[like]', $(temp) ).click( function() {
              if ( $(this).hasClass('active') ) { 
                $(this).removeClass('active');
                
                let myVar = setInterval(()=>{
                  let _like = $('.wk-item-column[handle="'+product.handle+'"] .wk-button-wishlist-page');
                  if ( !_like.hasClass('wk-add-product')) { 
                    $('.wk-item-column[handle="'+product.handle+'"] .wk-button-wishlist-page').click();
                    console.log(0);
                    clearInterval(myVar); 
                  }
                });
              
              }else { 
                $(this).addClass('active'); 
          
                let myVar = setInterval(()=>{
              	  let _like = $('.wk-item-column[handle="'+product.handle+'"] .wk-button-wishlist-page');
                  if ( !_like.hasClass('wk-remove-product')) { 
                    $('.wk-item-column[handle="'+product.handle+'"] .wk-button-wishlist-page').click();
                    console.log(1);
                    clearInterval(myVar); 
                  }
                });
                
              }

              wishlist.productHandle();
            } );
            
            $(temp).mouseenter(function() { 
              $( '[destroy]', $( this ) ).show( "fast" )
              $( '[like]', $( this ) ).show( "fast" )
            }).mouseleave(function() { 
              $( '[destroy]', $( this ) ).fadeOut( 150 )
              if ( !$( '[like]', $( this ) ).hasClass('active') ) $( '[like]', $( this ) ).fadeOut( 150 )
            });
            
            temp.appendTo('.wishlist-list').attr('product-id', product.id);

          }
        })
      })
	},
  	count: () => {
      let $wkCount = $('.site-header .wk-count')
  		  _count = $wkCount.text().replace( ')', '' ).replace( '(', '' )
      $wkCount.text(_count);
      $wkCount.addClass('done');
	},
    init: () => {
        let myVar = setInterval(()=>{
            let $wkCount = $('.site-header .wk-link');
            if ($wkCount.length > 0) {
              	wishlist.count();
                clearInterval(myVar);                
            }
        });
      if (location.pathname.indexOf('pages/shared-wishlist') > 0) {
        $('#wishlistCollection').addClass('shared');
        let myVar = setInterval(()=>{
          if( $('.wishlist-collection .wk-item-column .wk-variant-link').length > 0 ) {
          	
            wishlist.getImage();
            clearInterval(myVar); 
          }
        })
      }
      if ( location.pathname ==  "/pages/wishlist" ) {
        let myVar = setInterval(()=>{
          if( $('.wishlist-collection .wk-item-column .wk-variant-link').length > 0 ) {
            wishlist.getImage();
          	wishlist.changeView();
            clearInterval(myVar); 
          }
        })
      }
    },
    run: () => {
        wishlist.init()
    }
},
baners_slider = {
  init: () => {
   if($('.highlights-banners--section').length > 0 || $('#shopify-section-product-template').length > 0) {
      $.each($('.highlights-banners .swiper-container'), (key, val) => {
        window.baners_sliderFun($(val).attr('data-swiperId'));
      })
      $(window).resize(()=>{
          $.each($('.highlights-banners .swiper-container'), (key, val) => {
              window.baners_sliderFun($(val).attr('data-swiperId'));
          })
      })
	}
  },
  run: () => {
  	baners_slider.init();
  }  
},
products_slider = {
  init: () => {
   if($('.collection-template-alternative--section').length > 0 || $('.template-article').length > 0) {
    $.each($('.ba-wrapper .swiper-container'), (key, val) => {
      window.products_sliderFun($(val).attr('data-swiperId'));
    })
    $(window).resize(()=>{
      $.each($('.ba-wrapper .swiper-container'), (key, val) => {
        window.products_sliderFun($(val).attr('data-swiperId'));
      })
    })
    if($('.template-article').length > 0) {
      let counter = 0;
      let interval = setInterval( () => {
        if ($('#polecamy').length > 0) {
          if($('.product-recommendation')) {
            $('#polecamy').append($('.product-recommendation'))
            clearInterval(interval);
          }
        }
        if(counter > 20) {
          clearInterval(interval);
        }
        counter++;
      }, 250);
    }
	}
  },
  run: () => {
  	products_slider.init();
  }  
},
footer = {
  init: () => {
  	$('.site-footer__item.open').addClass('pre-open');
  	window.footerFun();
  },
  run: () => {
  	footer.init();
  }
},
sliderSection = {
  action: () => {
    $.each($('.slider-section .swiper-container'), (key, val) => {
      window.sliderFun($(val).attr('data-swiperId'));
    })
  },
  init: () => {
    if($('.slider-section').length > 0) {
  	  sliderSection.action();
      $(window).resize(()=>{
          sliderSection.action();
      })
    }
  },
  run: () => {
  	sliderSection.init();
  }
},
snizeProduct = {
  addViewControl: () => {
    let $panel = $('#snize_results .snize-main-panel'),
    $controls = $('.snize-main-panel-controls', $panel);
  
    if($('li', $controls).length == 1) $('li', $controls).css('display', 'none');
  },
  activeViewSort: (count) => {
  	if(!$('[data-view="'+count+'"]').hasClass('active')) {
        $('[data-view]').removeClass('active');
        $('[data-view="'+count+'"]').addClass('active');
      }

	  document.cookie = "snize_view="+count;

      $('#snize-search-results-grid-mode li.snize-product').each((i,v) => {
        $(v)[0].style.cssText = '';
      })
      $('#snize-search-results-grid-mode').removeClass().addClass('snize-'+count+'-columns');
  },
  addViewSort: () => {
  	let $panel = $('#snize_results .snize-main-panel');
    if ( $('.snize-view-sort').length == 0) {
      $panel.append('<div class="snize-view-sort">'+window.snize.view+'<a data-view="three"><span></span><span></span><span></span></a><a data-view="four"><span></span><span></span><span></span><span></span></a></div>');
    }
    $('.snize-filters-dropdown').click(function(){
      let $content = $('.snize-filters-dropdown-content ul li:nth-last-of-type(2)', $(this))
      if ($content.hasClass('snize-hidden') > 0) {
        $( '#snize-show-more-filters' ).on('click', function(){
          $(this).closest('li').hide()
          $('.snize-product-size-filter li').removeClass('snize-hidden')
        })
      }
    })

    $('[data-view]').click( function() {
      let count = $(this).attr('data-view');
      snizeProduct.activeViewSort(count);
  	});
	
    if(document.cookie.indexOf('snize_view=') != -1) {
      snizeProduct.activeViewSort(document.cookie.split('snize_view=')[1].split(';')[0]);
    }else {
      snizeProduct.activeViewSort('four');
    }
  },
  hideSpecificFilter: () => {
    document.querySelectorAll('#snize_filters_dropdown_tags .snize-product-filters-list li label > .needsclick').forEach((item) => {
      if (item.textContent.includes('Omnibus:')) item.closest('li').style = "display:none;";
    })
    document.querySelectorAll('#snize_product_filter_tags .snize-product-filters-list li label > .needsclick').forEach((item) => {
      if (item.textContent.includes('Omnibus:')) item.closest('li').style = "display:none;";
    })
    document.querySelectorAll('#snize_filters_dropdown_tags .snize-product-filters-list li label > .needsclick').forEach((item) => {
      if (item.textContent.includes('ERP_KOD_TOWARU')) item.closest('li').style = "display:none;";
    })
    document.querySelectorAll('#snize_product_filter_tags .snize-product-filters-list li label > .needsclick').forEach((item) => {
      if (item.textContent.includes('ERP_KOD_TOWARU')) item.closest('li').style = "display:none;";
    })
    
    Array.from(document.querySelectorAll('.snize-filters-dropdown-text')).forEach((item) => {
      if (item.innerText === 'cechy_glowne.Przeznaczenie') item.closest('.snize-filters-dropdown').style = "display:none;";
    })
    Array.from(document.querySelectorAll('.snize-product-filter-title')).forEach((item) => {
      if (item.innerText === 'cechy_glowne.Przeznaczenie') item.closest('.snize-product-filter-opener').style = "display:none;";
    })
  },
  changeView: () => {
    const config = {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    };
  
    const cartObserver = new MutationObserver(function(mutations) {
      if (mutations.length > 0) {
        snizeProduct.addViewSort();
      }
    });

    cartObserver.observe($('.snize-main-panel')[0], config);
  },
  viewSort: () => {
    let $snizeResults = $('#snize_results');  	
    if ( $snizeResults.length > 0 ) {
      
      let myVar = setInterval( () => {
		if ($('#snize_results .snize-main-panel .snize-main-panel-controls').length > 0) {
          snizeProduct.hideSpecificFilter();
          snizeProduct.addViewControl();
          snizeProduct.changeView();
          snizeProduct.addViewSort();
          setTimeout(function(){ $('.snize-results-preloader').remove(); }, 0);
          clearInterval(myVar);
        }
      });
    }
  },
  addNextImage: ($box) => {
  	$.each($('.snize-product', $box), (i,v) => {
  		
      let _productHandle = $('> .snize-view-link', $(v)).attr('href').split('products/')[1];
  		  
      $.getJSON('/products/'+_productHandle+'.js', function(product) {  		
        if( product.images.length > 1 ){  			
          let imageNext = 'https:'+product.images[1].toString();
  		  $('.searchanise-recommendations #snize-product-'+product.id).addClass('image-next');
          
          $('.searchanise-recommendations #snize-product-'+product.id+' .snize-item-image').after('<img src="'+imageNext+'" class="snize-item-image--next" alt="'+_productHandle+' next image" />');
        }
      } );
	})
  },
  addAttributesToLinks: (container) => {
    document.querySelectorAll(container + ' .snize-product').forEach(product => {
      const productLink = product.querySelector('.snize-view-link');
      const productTitle = product.querySelector('.snize-title').innerText;
      productLink.setAttribute("title", productTitle);
      productLink.setAttribute("rel", "dofollow");
    })
  },
  addChangeListener: () => {
    const containers = [];
    if(document.querySelector('#snize_results')) containers.push('#snize_results')
    if(document.querySelector('.searchanise-recommendations')) containers.push('.searchanise-recommendations')
    if(containers.length > 0 ) {
      document.addEventListener('Searchanise.Loaded', function() {
        (function($) {
          containers.forEach(container => snizeProduct.addAttributesToLinks(container))
          $( document ).on('Searchanise.ResultsUpdated Searchanise.AutocompleteUpdated Searchanise.RecommendationUpdated', () => {
            containers.forEach(container => snizeProduct.addAttributesToLinks(container))
            setTimeout(function(){ $('.snize-results-preloader').remove(); }, 3000);
            snizeProduct.hideSpecificFilter();
            setTimeout(function () {
              $('.snize-search-results .snize-product').each(function () {
                let productData = $(this).data('snize_item_data');
                fetchLowestPrice(productData).then(price => {
                  if (price) {
                    let priceFormatted = parseFloat(price).toLocaleString('de-DE', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    });
                    if ($(this).find('.lowest-price-omnibus').length === 0) {
                      $('.snize-price-list', this).append(
                          `<span class="snize-attribute snize-metafield-custom lowest-price-omnibus">Najniższa cena: ${priceFormatted} zł</span>`
                      );
                    }
                  }
                })
              });
            }, 0);
          })
        })(window.Searchanise.$);
      })

      async function fetchLowestPrice(productData) {
        try {
          const response = await fetch(productData.link);
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const moneyElem = doc.querySelector('.metafield-money');

          if (moneyElem) {
            return moneyElem.innerText.trim();
          } else {
            console.warn('No element with class ".metafield-money" found');
            return null;
          }
        } catch (error) {
          console.error('Fetch error:', error);
          return null;
        }
      }
    }
  },
  init: () => {
    let $snize = $('.searchanise-recommendations');
    if ( $snize.length > 0 ) {
      let myVar = setInterval( () => {
        if ($('.snize-product', $snize).length > 0) { 
          snizeProduct.addNextImage($snize);
          clearInterval(myVar);
        }
      });
    }
    snizeProduct.viewSort();
    $( window ).resize(function() {
      snizeProduct.viewSort();
    })
    snizeProduct.addChangeListener();
  },
  run: () => snizeProduct.init()
},
product_slider = {
  init: () => {
  	window.product_sliderFun();
  },
  run: () => {
  	product_slider.init();
  }
},
modal = {
  open: ($modal) => {
    $('body').removeClass('nav-fixed');
    $('#shopify-section-header').addClass('header-hide');
    
    setTimeout(()=>{
      $modal.attr('aria-hidden', false);
      window.scrollTo(0, 0); 
      $('html').css('overflow', 'hidden');
    }, 300)
  },
  close: ($modal) => {
    $('html').css('overflow', '');
    $modal.attr('aria-hidden', true);
    
    setTimeout( ()=> $('#shopify-section-header').removeClass('header-hide') , 300)
  },
  init: () => {
  	$('[data-action="open-modal"]').click(function(){
      modal.open($('#'+$(this).attr('aria-controls')));
    });
    $('[data-action="close-modal"]').click(function(){
      modal.close($($(this).closest('.Modal')));
    });
  },
  run: () => {
  	modal.init();
  }
}
product_colors = {
  init: () => {
    if($('.product-colors').length > 0){
  $('.product-colors a').mouseenter(function() {
  		$('.product-colors__name span').removeClass('active');
        $('.product-colors__name span[data-code="'+$(this).attr('data-code')+'"]').addClass('active');
  		$('.product-single__media-wrapper').removeClass('active');
  		$('#FeaturedMedia-product-template-'+$(this).attr('data-media-id')+'-wrapper').addClass('active');
  		$('.product-single__media-wrapper:not(.hide)').css('opacity', !$(this).hasClass('per-active') ? 0 : 1);
      });
      $('.product-colors').mouseleave(function(){
      	$('.product-colors__name span').removeClass('active');
        $('.product-single__media-wrapper').removeClass('active');
        $('.product-colors__name span.per-active').addClass('active');
        $('.product-single__media-wrapper').css('opacity', 1);
      })
    }
  },
  run: () => {
    product_colors.init();
  }
},
evalible_product = {
  init: () => {
  	if($('#contact_form').length > 0) {
      $('#contact_form .agree-label').slideUp(0);
      $('#contact_form [type="email"]').keyup(function(){
        $('#contact_form .agree-label').slideDown();
      })
    }
  },
  run: () => {
	evalible_product.init();
  }
},
average_link = {
  reviewCounter: () => {
  
    // options
    const config = {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    };
  
    // Create an observer instance linked to the callback function
    const cartObserver = new MutationObserver(function(mutations) {
      $.each(mutations, (i,mutation) => {
        if (mutation.type == 'childList') {
          average_link.activeReview();
//           console.log('star count change');
        }
      });
    });

    // Start observing the target node for configured mutations	
    cartObserver.observe($('#wc_review_section .wc_overall_review')[0], config);
  },
  activeReview: () => {
    const rating = Math.round(document.querySelector('.wc_review_count .wc_average_review_stars[data-avg]').getAttribute('data-avg'));
    if(rating === 0) {
      document.querySelector(`a[average-link] [name="rating_test"][value="5"]`).checked = true;
      return;
    }
    document.querySelector(`a[average-link] [name="rating_test"][value="${rating}"]`).checked = true;
  },
  init: () => {
	if($('a[average-link]').length > 0) {  
      $('a[average-link]').on('click', function (event) {
        if (this.hash !== "") {
          event.preventDefault();
          let hash = this.hash;

          $('html, body').animate({
            scrollTop: $(hash).offset().top
          }, 800, function () {
            window.location.hash = hash;
            if( $('#wc_product_review_form').length > 0 ) {
              $('#wc_product_review_form').slideDown('slow');
            }
          });
        }
      });
      if( $('#wc_review_section').length > 0 ) {
        let myVar = setInterval( () => {
          if ($('.wc_review_count').length > 0) {
            average_link.activeReview();
            average_link.reviewCounter();
            clearInterval(myVar);
          }
        });
      }
	}
  },
  run: () => {
    average_link.init();
  }
},
social_sharing = {
    init: () => {
        if ($('.social-sharing > li.icon-share').length) {
            $('.social-sharing > li.icon-share').click(() => {
                $('.social-sharing').toggleClass('active')
            })
        }
    },
    run: () => {
        social_sharing.init();
    }
};
window.lightbox = {
  drag: () => {
  
    $.each( $(".lupe-image__container"), (key, item) => {

      let el = $(item)[0];
      let x = 0, y = 0, top = 0, left = 0;

      let draggingFunction = (e) => {
          document.addEventListener('mouseup', () => {
              document.removeEventListener("mousemove", draggingFunction);
          });

          el.scrollLeft = left - e.pageX + x;
          el.scrollTop = top - e.pageY + y;
      };

      el.addEventListener('mousedown', (e) => {
          e.preventDefault();

          y = e.pageY;
          x = e.pageX;
          top = el.scrollTop;
          left = el.scrollLeft;

          document.addEventListener('mousemove', draggingFunction);
      });

  	})

  },
  move_status: ($container, status) => {
    let _neighbor_selector = '.product-single__media-wrapper:not(.img-color)',
        _prev_status = $container.prev( _neighbor_selector ).length == 0,
        _next_status = $container.next( _neighbor_selector ).length == 0;
    
    if ( _prev_status && _next_status ) {
      $('.lightbox .prev').addClass('disable')
      $('.lightbox .next').addClass('disable')
    }else if ( _prev_status ) {
      $('.lightbox .next').removeClass('disable')
      $('.lightbox .prev').addClass('disable')
    }else if ( _next_status ) {
      $('.lightbox .prev').removeClass('disable')
      $('.lightbox .next').addClass('disable')
    }else {
      $('.lightbox .prev').removeClass('disable')
      $('.lightbox .next').removeClass('disable')
    }
    
  },
  move: (status, $container, $neighbor, _neighbor_selector) => {
    
    $('.product-single__media-wrapper.more .lupe-image img').css('height', '100vh');
    $('.plus').removeClass('disable'); $('.minus').addClass('disable');
    $('.product-single__media-wrapper.more').removeClass('more').removeAttr('more');
    
    if( $neighbor.length > 0 ) {
    
      $container.addClass('hide').removeClass('perLightbox').removeClass('isLightbox');
      $neighbor.removeClass('hide').addClass('perLightbox').addClass('isLightbox');

      $('.lupe-image', $neighbor).attr('style', $('.lupe-image', $container).attr('style'));
      $('.lupe-image', $container).removeAttr("style");
      
    }
    
    lightbox.move_status($neighbor, status);

  },
  overflow: (action) => {
    $('html, body').css({
      overflow: action ? 'hidden' : ''
    });

    if (action) $('#shopify-section-header').addClass('header-hide');
    else $('#shopify-section-header').removeClass('header-hide');
    
  },
  init: () => {
    let $lightbox = $('.lightbox');
    
	  $('.product-single__media-wrapper:not(.img-color)').on( "click", function() {
  		if( !$(this).hasClass('perLightbox') && document.readyState === "complete") {

        let $father = $(this),
            $imgIn = $('.lupe-image', $father),
            _imgX = $imgIn.offset().left, 
            _imgY = $('.lupe-image img', $father)[0].y;

        lightbox.overflow(true);
        $lightbox.removeClass('off');
        $father.addClass('perLightbox');	  
        $imgIn.css({ left: _imgX, top: _imgY });

        setTimeout(function(){
          console.log($father)
          $father.addClass('isLightbox');
        }, 10);

        lightbox.move_status($father);
      }
    })  
    
    $('.close', $lightbox).click(()=>{
      let $container = $('.product-single__media-wrapper.perLightbox:not(.hide)'),
		      $img = $('.lupe-image', $container);
	
      $('.product-single__media-wrapper.more .lupe-image img').css('height', '100vh');
      $('.plus').removeClass('disable'); $('.minus').addClass('disable');
      $('.product-single__media-wrapper:not(.hide):not(.img-color)').removeClass('more').removeAttr('more');
		
	    lightbox.overflow();
      $lightbox.addClass('off');
      $container.addClass('ofLightbox');

      $container.removeClass('isLightbox');
		
      setTimeout(function(){ 
        $img.css({
          left: 0,
          top: 0
        })
        $container.removeClass('perLightbox');
        $container.removeClass('ofLightbox');
      }, 300);
		
      $('.prev', $lightbox).removeClass('disable');
      $('.next', $lightbox).removeClass('disable');
    });

	  $('.next', $lightbox).click(()=>{
      if(!$('.next', $lightbox).hasClass('disable')) {                     
        lightbox.move(
          'next', 
          $('.product-single__media-wrapper:not(.hide):not(.img-color)'), 
          $('.product-single__media-wrapper:not(.hide):not(.img-color)').next( '.product-single__media-wrapper:not(.img-color)' )
        );
      }
    })
    
    $('.prev', $lightbox).click(()=>{
    	if(!$('.prev', $lightbox).hasClass('disable')) {                                    
        lightbox.move(
          'prev', 
          $('.product-single__media-wrapper:not(.hide):not(.img-color)'), 
          $('.product-single__media-wrapper:not(.hide):not(.img-color)').prev( '.product-single__media-wrapper:not(.img-color)' )
        );
    	}
    })
    
    $('.plus:not(.disable)', $lightbox).click(()=>{
      let $container = $('.product-single__media-wrapper:not(.hide):not(.img-color)'),
          _count = $container.attr('more');
      if (_count < 8 || typeof(_count) == 'undefined') { 
        $container.addClass('more').attr('more', _count ? parseInt(_count)+2 : 2);
        $('.lupe-image img', $container).css('height', (_count ? 120 + (parseInt(_count)*10) : 120) +'vh'); 
      }

		  $('.minus').removeClass('disable');
      if ( _count == 6 ) $('.plus').addClass('disable'); 
	  })
    
    lightbox.drag();

    $('.minus', $lightbox).click(()=>{
      if(!$('.minus').hasClass('disable')) {
        let $container = $('.product-single__media-wrapper:not(.hide):not(.img-color)'),
      		_count = $container.attr('more');
        if (_count >= 2 || typeof(_count) == 'undefined') { 
          $container.attr('more', _count ? parseInt(_count)-2 : 0); 
          $('.lupe-image img', $container).css('height', (_count ? (100 + (parseInt(_count)*10)) - 20 : 100) +'vh');
        }

		$('.plus').removeClass('disable');

      	if(_count == 2) { $container.removeClass('more'); $('.minus').addClass('disable'); }
      
      	var $window = $(".lupe-image__container", $container),
        $element = $('.lupe-image img', $container),
        elementTop = $element.offset().top,
        elementHeight = $element.height(),
        viewportHeight = $window.height(),
        scrollIt = elementTop - ((viewportHeight - elementHeight) / 2);

        $window.scrollTop(scrollIt);
      }
	  })

    $(document).keyup(function(e) {
      if ( $( '.isLightbox' ).length > 0 ) {
        if (e.keyCode === 27) $('.close', $lightbox).click(); // esc
        if (e.keyCode == '37') $('.prev:not(.disable)', $lightbox).click(); // left arrow
        if (e.keyCode == '39') $('.next', $lightbox).click();	// right arrow
        if (e.keyCode == '107' || e.keyCode == '38') $('.plus:not(.disable)', $lightbox).click();	// plus
        if (e.keyCode == '109' || e.keyCode == '40') $('.minus:not(.disable)', $lightbox).click(); // minus
      }
    });

    $('.open-lightbox').on('touchstart', function (e) {
      console.log(e);
      $('#product-photos').addClass('activeLightbox'); 
		let wrapper_id = $('#product-photos .swiper-slide-active [data-thumbnail-id]').click().attr('data-thumbnail-id');
		$('.product-single__media-wrapper:not(.img-color)[data-media-id="'+wrapper_id+'"]').click();
    })
  },
  run: () => {
    lightbox.init();
  }
};
let option_size = {
  init: () => {
  	let $option_size = $('.option-size--select');
  	if( $option_size.length > 0 ) {
      $('.item', $option_size).on( 'click', function() {
        if ( !$(this).hasClass('active') ) {
          $('.item.active', $option_size).removeClass('active');
          $(this).addClass('active');
          $('~ .select', $option_size).val($(this).attr('data-value')).change();
        }
      })
    }
  },
  run: () => {
    option_size.init();
  }
},
metafields = {
  block: $('.template-product #metafields'),
  init: () => {
    if( metafields.block.length > 0 && metafields.block.html().trim() == '' ) {  
      $('#shopify-section-product-metafields').remove();
      product_section_nav.run();
    }
  },
  run: () => {
  	metafields.init();
  }
},
product_section_nav = {
  init: () => {
    if( $('.template-product #MainContent').length > 0 ) {
      $('.product-section-nav').empty();
      let phone = window.media_queries.phone;
  
      $.each( $('.template-product #MainContent .shopify-section:not(#shopify-section-product-template)'), (key, section) => {
 
        if ( $('.section-header', section).text().replace(/\s/g,'') != '') {
  
          $(section).addClass('section-nav');
          $('.section-header', $(section)).unbind();
          $('.section-header', $(section)).click((e) => {
            if ( $( window ).width() < phone || e.target.classList.contains('gpsr') || e.target.closest('.gpsr')) {
              if ($('[searchanise]', $(section)).hasClass('action') ) $('[searchanise]', $(section)).removeClass("action").css('display', 'none');
  			  $('.section-header', $(section)).toggleClass("open");
              $('.section-header ~ *', $(section)).slideToggle("slow");
            }
          })
  
          $( '<div class="section-nav__item">'+$('.section-header', section).text().trim()+'</div>' ).appendTo( $('.product-section-nav') ).click( function() {          
  			$("html, body").animate({ scrollTop: $(section).offset().top }, 1000);
          });
          
        }
      }) 
      
      $( window ).resize(() => {
		if ( $( window ).width() > phone) {
        	if (typeof $('.section-nav .section-header ~ *').attr('style') != 'undefined') $('.section-nav .section-header ~ *').attr('style', $('.section-nav .section-header ~ *').attr('style').toString().replace('display: none;', '').replace('display: block;', ''));
      	}
      })
  	}
  },
  run: () => {
    product_section_nav.init();
  }
};
window.faq = {
  init: () => {
    if ( $( '#shopify-section-faq-template' ).length > 0 ) {
  	$.each( $('.Faq-Item.isAnswer'), ( key, item ) => {
  		let $btn = $( 'button', $( item ) );
        if ( key == 0 ) {
          $btn.addClass("open");
          $( '.Faq-Item__Answer', $( item ) ).slideDown(250);
        }

		$btn.unbind("click");
  
		$btn.bind("click", function(){
          if ( $(this).hasClass( "open" ) ) {
            $(this).removeClass("open");
          	$( '.Faq-Item__Answer', $( item ) ).slideUp(250) 
          }else {
            $(this).addClass("open");
            $( '.Faq-Item__Answer', $( item ) ).slideDown(250) 
             
          }
      	})
	  })
  	}
  },
  run: () => {
  	faq.init();
  }
}
$(document).on('shopify:section:load', function(event) {
  AOS.init();
})
$(document).on('shopify:section:select', function(event) {
  AOS.init();
});
$(window).load(()=> {
  AOS.init();
})

$(document).ready(()=>{
  wishlist.run()
  baners_slider.run()
  products_slider.run()
  footer.run();
	sliderSection.run();
	snizeProduct.run();
	product_slider.run();
	modal.run();
	product_colors.run();
	evalible_product.run();
	average_link.run();
	social_sharing.run();
	window.lightbox.run();
	option_size.run();
	metafields.run();
	product_section_nav.run();
	window.faq.run();
	AOS.init();
})